export default "/images/vendor/@coreui/icons/svg/flag/cif-dz.svg?84223cc2dcbaa66d8180c6f9aea8bcc1";